module.exports = __webpack_public_path__ + "img/down-chevron.a1e7db27.svg";